module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.lib.libMerge({"options":{"~.Join_Form":{"wrapMethods.prepareTransaction":[{"value":true,"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101002},"path":"~.Join_Form","_fox_":1}],"hooks.onStartPrepareTransaction":[{"value":function (formData) {
var fields = ['username', 'password', 'email'];
fox.each(formData, function (v, key) {
formData[key] = (fields.indexOf(key) !== -1) ? fox.trim(v) : v;
});
var linkerParam = this.rwom1('@root #googleAnalytics').getLinkerParam();
if (linkerParam) {
formData['transitParams[_ga]'] = linkerParam;
}
return true;
},"lWeight":true,"desc":{"level":1,"weightDesc":[],"weight":101013},"path":"~.Join_Form","_fox_":1}]}}})
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/options/joinForm.js
// module id = 666
// module chunks = 4